var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"mb-4"},[_vm._v(" Page not found! ")]),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v(" Back to Home ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }